import React, {useState} from 'react';
import './mLargeViewMeetingStatusComponent.css';
import VIDABOO_CONSTANTS from '../../../../../../../../../config/consts';
import Info from '../../../../../../../../../assets/png/info-icon.png';
import MCalendarLegendComponent from '../../../../mCalendarLegendComponent';

const MLargeViewMeetingStatusComponent = ({
  meetingStatus,
  statusText,
  hideTooltip = false,
}) => {
  const [showStatusesTooltip, setShowStatusesTooltip] = useState(false);
  const getBgClassName = (meetingStatus) => {
    switch (meetingStatus) {
      case VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CONFIRMED:
        return 'et-n-cec-confirmed-sidebar';
      case VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CREATED:
        return 'et-n-cec-created-sidebar';
      case VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.CANCELLED:
        return 'et-n-cec-cancelled-sidebar';
      case VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.DECLINED:
        return 'et-n-cec-declined-sidebar';
      case VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.OVERDUE:
        return 'et-n-cec-overdue-sidebar et-n-cec-black-color';
      case 'PENDING':
        return 'et-n-cec-pending-sidebar et-n-cec-black-color';
      case 'PROPOSALS':
        return 'et-n-cec-proposals-bg-color';
      case 'ANONYMOUS':
        return 'et-n-cec-anonymous-bg-color';
      default:
        return 'et-n-cec-create-new-sidebar';
    }
  };

  return (
    <>
      <div
        className={`et-n-cec-sidebar  ${
          meetingStatus !== 'PROPOSALS' && meetingStatus !== 'ANONYMOUS'
            ? getBgClassName(meetingStatus)
            : ''
        }`}></div>
      <div
        className={`et-n-cec-meeting-status-name ${getBgClassName(
          meetingStatus,
        )}`}>
        {statusText}
      </div>{' '}
      {meetingStatus === VIDABOO_CONSTANTS.BOOKING_FLOW_STATES.OVERDUE && (
        <div className="et-n-cec-meeting-status-overdue-pill">PASSED</div>
      )}
      {!hideTooltip && (
        <div className="et-n-cec-meeting-status-legend-wrap">
          <img
            onMouseEnter={() => setShowStatusesTooltip(true)}
            onMouseLeave={() => setShowStatusesTooltip(false)}
            className="et-n-cec-meeting-status-legend-icon"
            src={Info}
            alt={'info'}
          />
          {showStatusesTooltip && <MCalendarLegendComponent />}
        </div>
      )}
    </>
  );
};

export default MLargeViewMeetingStatusComponent;
